import type { Group } from 'three';
import { mergeByMaterial } from '../../render/mergeByMaterial';

/** A trotro goes from ~35 draw calls to ~10 once parts sharing a material are merged. */
export function bakeVehicle(source: Group): Group {
  return mergeByMaterial(source, { castShadow: true });
}
